function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.5999 36.8C29.8783 36.8 37.3999 29.2783 37.3999 20C37.3999 10.7216 29.8783 3.19995 20.5999 3.19995C11.3215 3.19995 3.79993 10.7216 3.79993 20C3.79993 29.2783 11.3215 36.8 20.5999 36.8Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20.6 39.9998C31.6481 39.9998 40.5998 31.0482 40.5998 20C40.5998 8.95163 31.6481 0 20.6 0C9.55161 0 0.599976 8.95163 0.599976 20C0.599976 31.0482 9.55161 39.9998 20.6 39.9998ZM9.75161 19.5666L29.0349 12.1316C29.9299 11.8083 30.7115 12.35 30.4216 13.7033L30.4232 13.7016L27.1398 29.1699C26.8966 30.2666 26.2449 30.5333 25.3333 30.0165L20.3333 26.3315L17.9216 28.6549C17.6549 28.9216 17.4299 29.1466 16.9133 29.1466L17.2683 24.0582L26.5349 15.6866C26.9382 15.3316 26.4449 15.1316 25.9133 15.4849L14.4616 22.6949L9.52494 21.1549C8.45329 20.8149 8.42994 20.0832 9.75161 19.5666Z",
  fill: "#373D4C"
});

var SvgTgLogo = function SvgTgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tg-logo.9afadaa2.svg";
export { ForwardRef as ReactComponent };